import { message, Tabs, Select, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    InputNumberItem,
    SelectDescansosItem,
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";
import TimePickerItem from "../../../../Components/TimePickerItem";
import { secondsToHms, timeToSeconds } from "../../../../Components/TimeConvertions";
import { MARGEN_VENTANA_MIN, acotarSalto, ventanaDesdeBase } from "../ventanaHorario";
import moment from "moment";

const { TabPane } = Tabs;
const { Option } = Select;

class EditarHorario extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarTodo();
        }
    }

    cerrarEditarHorario(codigo) {
        this.props.cerrarEditarHorario(codigo);
    }

    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "horarios/datosHorario",
                { empresaId: this.props.empresaId, horarioId: this.props.horarioId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...res.data.data,
                        entrada: secondsToHms(res.data.data.entradaSeg),
                        salida: secondsToHms(res.data.data.salidaSeg),
                        cambioDeDia: secondsToHms(res.data.data.cambioDeDiaSeg),
                        inicioEntrada: res.data.data.inicioEntradaSeg ? secondsToHms(res.data.data.inicioEntradaSeg) : null,
                        finEntrada: res.data.data.finEntradaSeg ? secondsToHms(res.data.data.finEntradaSeg) : null,
                        inicioSalida: res.data.data.inicioSalidaSeg ? secondsToHms(res.data.data.inicioSalidaSeg) : null,
                        finSalida: res.data.data.finSalidaSeg ? secondsToHms(res.data.data.finSalidaSeg) : null,
                    });
                } else {
                    message.error("Error no se encontro informacion del horario");
                }
            });
        this.setState({ loading: false }); // resetear opciones
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    autollenarVentanaEntrada() {
        const entrada = this.formRef.current.getFieldValue("entrada");
        if (!entrada) return;

        const inicio = ventanaDesdeBase(entrada, -MARGEN_VENTANA_MIN);
        const fin = ventanaDesdeBase(entrada, MARGEN_VENTANA_MIN);

        this.formRef.current.setFieldsValue({
            inicioEntrada: inicio.hora,
            inicioEntradaSalto: acotarSalto(inicio.salto, -3, 0),
            finEntrada: fin.hora,
            finEntradaSalto: acotarSalto(fin.salto, 0, 3),
        });
    }

    autollenarVentanaSalida() {
        const salida = this.formRef.current.getFieldValue("salida");
        if (!salida) return;

        const saltoSalida = Number(this.formRef.current.getFieldValue("salidaSalto") || 0);
        const inicio = ventanaDesdeBase(salida, -MARGEN_VENTANA_MIN);
        const fin = ventanaDesdeBase(salida, MARGEN_VENTANA_MIN);

        this.formRef.current.setFieldsValue({
            inicioSalida: inicio.hora,
            inicioSalidaSalto: acotarSalto(saltoSalida + inicio.salto, 0, 3),
            finSalida: fin.hora,
            finSalidaSalto: acotarSalto(saltoSalida + fin.salto, 0, 3),
        });
    }

    onFinish(values) {
        // ============
        // Conversión a segundos
        // ============
        const entradaSeg = timeToSeconds(values.entrada);
        const salidaSeg = timeToSeconds(values.salida);

        const cambioDeDiaSeg = timeToSeconds(values.cambioDeDia); // opcional, por si lo usas

        if (entradaSeg == null || salidaSeg == null) {
            message.error("Selecciona Entrada y Salida.");
            return;
        }

        const validarRango = (x, nombre) => {
            if (x == null) return true;
            if (x < 0 || x > 86399) {
                message.error(`${nombre}: hora inválida.`);
                return false;
            }
            return true;
        };

        if (!validarRango(entradaSeg, "Entrada")) return;
        if (!validarRango(salidaSeg, "Salida")) return;
        if (!validarRango(cambioDeDiaSeg, "Cambio de día")) return;

        // ============
        // Payload (mapea a tu schema)
        // ============
        const payload = {
            ...values,
            horarioId: this.props.horarioId,
            empresaId: this.props.empresaId,

            // Guardar segundos
            entradaSeg,
            salidaSeg,
            cambioDeDiaSeg: cambioDeDiaSeg ?? null,

            // Defaults útiles si no mandas ventanas aún
            // (si luego vas a usar inicio/fin de entrada/salida)
            inicioEntradaSeg: values.inicioEntrada ? timeToSeconds(values.inicioEntrada) : null,
            finEntradaSeg: values.finEntrada ? timeToSeconds(values.finEntrada) : null,
            inicioSalidaSeg: values.inicioSalida ? timeToSeconds(values.inicioSalida) : null,
            finSalidaSeg: values.finSalida ? timeToSeconds(values.finSalida) : null,

            // Salto (si no mandas, default 0)
            inicioEntradaSalto: Number(values.inicioEntradaSalto || 0),
            finEntradaSalto: Number(values.finEntradaSalto || 0),
            inicioSalidaSalto: Number(values.inicioSalidaSalto || 0),
            finSalidaSalto: Number(values.finSalidaSalto || 0),

            salidaSalto: Number(values.salidaSalto || 0),
        };

        // Remueve los moment del payload (para no mandar objetos raros)
        delete payload.entrada;
        delete payload.salida;
        delete payload.cambioDeDia;
        delete payload.inicioEntrada;
        delete payload.finEntrada;
        delete payload.inicioSalida;
        delete payload.finSalida;

        this.setState({ loading: true });

        axios
            .post("horarios/editarHorario", payload, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado un horario");
                    this.formRef.current.resetFields();
                    this.cerrarEditarHorario(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede editar el horario");
                } else {
                    message.error("Hubo un error y el horario no se editó");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error de red al editar el horario");
            });
    }

    render() {

        return (
            <>
                <ModalItem
                    title="Editar Horario"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarHorario.bind(this)}
                    paddingTop
                    width={1500}
                >
                    <Form
                        ref={this.formRef}
                        name="editarHorario"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        {/* ======================
                ENCABEZADO
            ====================== */}

                        <FormItem
                            name="horarioFlexible"
                            label="Horario flexible"
                            margin
                            valuePropName="checked"
                            initialValue={false}
                        >
                            <SwitchItem />
                        </FormItem>

                        <FormItem name="nombre" label="Nombre" required max={100} margin pattern>
                            <InputItem placeholder="Nombre" />
                        </FormItem>

                        <FormItem name="descripcion" label="Descripción" margin pattern>
                            <TextAreItem placeholder="Descripción" />
                        </FormItem>

                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) =>
                                getFieldValue("horarioFlexible") ? (
                                    <Tabs defaultActiveKey="1">
                                        {/* ======================
                  BASICO
              ====================== */}
                                        <TabPane tab="Básico" key="1">
                                            <Row gutter={12}>
                                                <Col span={8}>
                                                    <FormItem
                                                        name="entrada"
                                                        label="Entrada"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(8).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem placeholder="Entrada" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="salida"
                                                        label="Salida"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(18).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem placeholder="Salida" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                    <FormItem
                                                        name="salidaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem placeholder="Salto dias" >
                                                            <Option value={0}>0</Option>
                                                            <Option value={1}>1</Option>
                                                            <Option value={2}>2</Option>
                                                            <Option value={3}>3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="tiempoTrabajo"
                                                        label="Tiempo trabajo (min)"
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0}
                                                    >
                                                        <InputNumberItem />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="jornadaDeTrabajo"
                                                        label="Jornada"
                                                        required
                                                        margin
                                                        type="number"
                                                        max={5}
                                                        initialValue={1}
                                                    >
                                                        <InputNumberItem placeholder="Jornada (días)" />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="tipoTrabajo" label="Tipo trabajo" margin initialValue={1}>
                                                        <SelectItem placeholder="Tipo trabajo">
                                                            <Option value={1}>Normal</Option>
                                                            <Option value={2}>Día de descanso</Option>
                                                            <Option value={3}>Fin de semana</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="resultadoCumpleMin" label="Resultado (si cumple)" margin initialValue={1}>
                                                        <SelectItem placeholder="Resultado si cumple">
                                                            <Option value={1}>Presente</Option>
                                                            <Option value={2}>Presente + horas extra (excedente)</Option>
                                                            <Option value={3}>Todo como horas extra</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="resultadoNoCumpleMin"
                                                        label="Resultado (si no cumple)"
                                                        margin
                                                        initialValue={0}
                                                        tooltip='Las horas extra solo se calculan si "Salida tardía" (pestaña Fuera de horario) no está en "Ignorar".'
                                                    >
                                                        <SelectItem placeholder="Resultado si no cumple">
                                                            <Option value={0}>- (nada)</Option>
                                                            <Option value={1}>Falta</Option>
                                                            <Option value={2}>Día de descanso</Option>
                                                            <Option value={3}>Fin de semana</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                </Col>
                                            </Row>
                                        </TabPane>


                                        {/* ======================
                  FUERA DE HORARIO
              ====================== */}
                                        <TabPane tab="Fuera de horario" key="3">
                                            <Row gutter={12}>

                                                <Col span={12}>
                                                    <FormItem
                                                        name="salidaTardia"
                                                        label="Salida tardía"
                                                        margin
                                                        required
                                                        initialValue={1}
                                                    >
                                                        <SelectItem placeholder="Salida tardía">
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Mover a trabajo normal</Option>
                                                            <Option value={3}>Mover a tiempo extra normal</Option>
                                                            <Option value={4}>Mover a tiempo extra fin de semana</Option>
                                                            <Option value={5}>Mover a tiempo extra festivo</Option>
                                                        </SelectItem>
                                                    </FormItem>

                                                </Col>
                                                <Col span={12}>

                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("salidaTardia") !== 1 ? (
                                                                <FormItem
                                                                    name="minimoSalidaTardiaMin"
                                                                    label="Mínimo salida tardía (min)"
                                                                    margin
                                                                    type="number"
                                                                    max={1440}
                                                                    initialValue={0}
                                                                >
                                                                    <InputNumberItem placeholder="0" />
                                                                </FormItem>
                                                            ) : null
                                                        }
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </TabPane>

                                        {/* ======================
                  TIEMPO EXTRA
              ====================== */}
                                        <TabPane tab="Tiempo extra" key="4">
                                            <Row gutter={12}>
                                                <Col span={12}>
                                                    <FormItem name="tiempoExtra" label="Tiempo extra" margin required initialValue={1}>
                                                        <SelectItem placeholder="Tiempo extra">
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Dependiendo del tipo de trabajo</Option>
                                                            <Option value={3}>Dependiendo del tiempo extra</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) =>
                                                        getFieldValue("tiempoExtra") !== 1 ? (
                                                            <>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel1Horas"
                                                                        label="Nivel 1 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel2Horas"
                                                                        label="Nivel 2 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel3Horas"
                                                                        label="Nivel 3 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>
                                                            </>
                                                        ) : null
                                                    }
                                                </FormItem>
                                            </Row>
                                        </TabPane>

                                        {/* ======================
                  REGLAS
              ====================== */}
                                        <TabPane tab="Reglas" key="5">
                                            <Row gutter={12}>
                                                <Col span={12}>

                                                    <FormItem
                                                        name="checadaEntradaNecesaria"
                                                        label="Checada entrada necesaria"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="checadaSalidaNecesaria"
                                                        label="Checada salida necesaria"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                    <FormItem
                                                        name="basadoEnEstadoDispositivo"
                                                        label="Basado en estado dispositivo"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="checadaDuplicadaBase"
                                                        label="Checada duplicada"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                    <FormItem
                                                        name="entradasSalidasMultiples"
                                                        label="Entradas y salidas múltiples"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>

                                                    <FormItem
                                                        name="cambioDeDia"
                                                        label="Cambio de día"
                                                        margin
                                                        initialValue={moment().hour(0).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem placeholder="Ej. 00:00:00" format="HH:mm:ss" />
                                                    </FormItem>

                                                    <FormItem
                                                        name="toleranciaRetardoMin"
                                                        label="Tolerancia retardo (min)"
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0}
                                                    >
                                                        <InputNumberItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="toleranciaSalidaTempranaMin"
                                                        label="Tolerancia salida temprana (min)"
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0}
                                                    >
                                                        <InputNumberItem />
                                                    </FormItem>

                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("checadaDuplicadaBase") ? (
                                                                <FormItem
                                                                    name="checadaDuplicadaMin"
                                                                    label="Checada duplicada (min)"
                                                                    required
                                                                    margin
                                                                    initialValue={1}
                                                                    type="number"
                                                                    max={1440}
                                                                >
                                                                    <InputNumberItem />
                                                                </FormItem>
                                                            ) : null
                                                        }
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </Tabs>
                                ) : (
                                    <Tabs defaultActiveKey="1">
                                        {/* ======================
                  BASICO
              ====================== */}
                                        <TabPane tab="Básico" key="1">
                                            <Row gutter={12}>
                                                <Col span={8}>
                                                    <FormItem
                                                        name="entrada"
                                                        label="Entrada"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(8).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem
                                                            placeholder="Entrada"
                                                            format="HH:mm:ss"
                                                            onChange={this.autollenarVentanaEntrada.bind(this)}
                                                        />
                                                    </FormItem>
                                                </Col>
                                                <Col span={4}>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="salida"
                                                        label="Salida"
                                                        required
                                                        margin
                                                        initialValue={moment().hour(18).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem
                                                            placeholder="Salida"
                                                            format="HH:mm:ss"
                                                            onChange={this.autollenarVentanaSalida.bind(this)}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                    <FormItem
                                                        name="salidaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem
                                                            placeholder="Salto dias"
                                                            onChange={this.autollenarVentanaSalida.bind(this)}
                                                        >
                                                            <Option value={0}>0</Option>
                                                            <Option value={1}>1</Option>
                                                            <Option value={2}>2</Option>
                                                            <Option value={3}>3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="inicioEntrada" label="Inicio entrada" margin required>
                                                        <TimePickerItem placeholder="Opcional" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                    <FormItem
                                                        name="inicioEntradaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem placeholder="Salto dias" >
                                                            <Option value={0}>0</Option>
                                                            <Option value={-1}>-1</Option>
                                                            <Option value={-2}>-2</Option>
                                                            <Option value={-3}>-3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="inicioSalida" label="Inicio salida" margin required>
                                                        <TimePickerItem placeholder="Opcional" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>

                                                <Col span={4}>
                                                    <FormItem
                                                        name="inicioSalidaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem placeholder="Salto dias" >
                                                            <Option value={0}>0</Option>
                                                            <Option value={1}>1</Option>
                                                            <Option value={2}>2</Option>
                                                            <Option value={3}>3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="finEntrada" label="Fin entrada" margin required>
                                                        <TimePickerItem placeholder="Opcional" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={4}>
                                                    <FormItem
                                                        name="finEntradaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem placeholder="Salto dias" >
                                                            <Option value={0}>0</Option>
                                                            <Option value={1}>1</Option>
                                                            <Option value={2}>2</Option>
                                                            <Option value={3}>3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem name="finSalida" label="Fin salida" margin required>
                                                        <TimePickerItem placeholder="Opcional" format="HH:mm:ss" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={4}>
                                                    <FormItem
                                                        name="finSalidaSalto"
                                                        label="Salto"
                                                        required
                                                        margin
                                                        initialValue={0}
                                                    >
                                                        <SelectItem placeholder="Salto dias" >
                                                            <Option value={0}>0</Option>
                                                            <Option value={1}>1</Option>
                                                            <Option value={2}>2</Option>
                                                            <Option value={3}>3</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col span={8}>
                                                    <FormItem
                                                        name="jornadaDeTrabajo"
                                                        label="Jornada"
                                                        required
                                                        margin
                                                        type="number"
                                                        max={5}
                                                        initialValue={1}
                                                    >
                                                        <InputNumberItem placeholder="Jornada (días)" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </TabPane>

                                        <TabPane tab="Descansos" key="2">
                                            {/* ======================
                DESCANSOS (Select)
            ====================== */}
                                            <FormItem name="descansosIds" label="Descansos" margin>
                                                <SelectDescansosItem
                                                    mode="multiple"
                                                    placeholder="Selecciona descansos"
                                                    empresaId={this.props.empresaId}
                                                    headersToken={this.props.headersToken}
                                                />
                                            </FormItem>
                                        </TabPane>

                                        {/* ======================
                  FUERA DE HORARIO
              ====================== */}
                                        <TabPane tab="Fuera de horario" key="3">
                                            <Row gutter={12}>
                                                <Col span={12}>
                                                    <FormItem
                                                        name="entradaTemprana"
                                                        label="Entrada temprana"
                                                        margin
                                                        required
                                                        initialValue={1}
                                                    >
                                                        <SelectItem placeholder="Entrada temprana">
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Mover a trabajo normal</Option>
                                                            <Option value={3}>Mover a tiempo extra normal</Option>
                                                            <Option value={4}>Mover a tiempo extra fin de semana</Option>
                                                            <Option value={5}>Mover a tiempo extra festivo</Option>
                                                        </SelectItem>
                                                    </FormItem>

                                                </Col>
                                                <Col span={12}>

                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("entradaTemprana") !== 1 ? (
                                                                <FormItem
                                                                    name="minimoEntradaTempranaMin"
                                                                    label="Mínimo entrada temprana (min)"
                                                                    margin
                                                                    type="number"
                                                                    max={1440}
                                                                    initialValue={0}
                                                                >
                                                                    <InputNumberItem placeholder="0" />
                                                                </FormItem>
                                                            ) : null
                                                        }
                                                    </FormItem>
                                                </Col>

                                                <Col span={12}>
                                                    <FormItem
                                                        name="salidaTardia"
                                                        label="Salida tardía"
                                                        margin
                                                        required
                                                        initialValue={1}
                                                    >
                                                        <SelectItem placeholder="Salida tardía">
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Mover a trabajo normal</Option>
                                                            <Option value={3}>Mover a tiempo extra normal</Option>
                                                            <Option value={4}>Mover a tiempo extra fin de semana</Option>
                                                            <Option value={5}>Mover a tiempo extra festivo</Option>
                                                        </SelectItem>
                                                    </FormItem>

                                                </Col>
                                                <Col span={12}>

                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("salidaTardia") !== 1 ? (
                                                                <FormItem
                                                                    name="minimoSalidaTardiaMin"
                                                                    label="Mínimo salida tardía (min)"
                                                                    margin
                                                                    type="number"
                                                                    max={1440}
                                                                    initialValue={0}
                                                                >
                                                                    <InputNumberItem placeholder="0" />
                                                                </FormItem>
                                                            ) : null
                                                        }
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </TabPane>

                                        {/* ======================
                  TIEMPO EXTRA
              ====================== */}
                                        <TabPane tab="Tiempo extra" key="4">
                                            <Row gutter={12}>
                                                <Col span={12}>
                                                    <FormItem name="tiempoExtra" label="Tiempo extra" margin required initialValue={1}>
                                                        <SelectItem placeholder="Tiempo extra">
                                                            <Option value={1}>Ignorar</Option>
                                                            <Option value={2}>Dependiendo del tipo de trabajo</Option>
                                                            <Option value={3}>Dependiendo del tiempo extra</Option>
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) =>
                                                        getFieldValue("tiempoExtra") !== 1 ? (
                                                            <>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel1Horas"
                                                                        label="Nivel 1 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel2Horas"
                                                                        label="Nivel 2 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <FormItem
                                                                        name="tiempoExtraNivel3Horas"
                                                                        label="Nivel 3 (horas)"
                                                                        margin
                                                                        type="number"
                                                                        max={24}
                                                                        initialValue={0}
                                                                    >
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                </Col>
                                                            </>
                                                        ) : null
                                                    }
                                                </FormItem>
                                            </Row>
                                        </TabPane>

                                        {/* ======================
                  REGLAS
              ====================== */}
                                        <TabPane tab="Reglas" key="5">
                                            <Row gutter={12}>
                                                <Col span={12}>

                                                    <FormItem
                                                        name="checadaEntradaNecesaria"
                                                        label="Checada entrada necesaria"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="checadaSalidaNecesaria"
                                                        label="Checada salida necesaria"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                    <FormItem
                                                        name="basadoEnEstadoDispositivo"
                                                        label="Basado en estado dispositivo"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="checadaDuplicadaBase"
                                                        label="Checada duplicada"
                                                        margin
                                                        valuePropName="checked"
                                                        initialValue={false}
                                                    >
                                                        <SwitchItem />
                                                    </FormItem>
                                                </Col>
                                                <Col span={12}>

                                                    <FormItem
                                                        name="cambioDeDia"
                                                        label="Cambio de día"
                                                        margin
                                                        initialValue={moment().hour(0).minute(0).second(0)}
                                                    >
                                                        <TimePickerItem placeholder="Ej. 00:00:00" format="HH:mm:ss" />
                                                    </FormItem>

                                                    <FormItem
                                                        name="toleranciaRetardoMin"
                                                        label="Tolerancia retardo (min)"
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0}
                                                    >
                                                        <InputNumberItem />
                                                    </FormItem>

                                                    <FormItem
                                                        name="toleranciaSalidaTempranaMin"
                                                        label="Tolerancia salida temprana (min)"
                                                        margin
                                                        type="number"
                                                        max={1440}
                                                        initialValue={0}
                                                    >
                                                        <InputNumberItem />
                                                    </FormItem>

                                                    <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) =>
                                                            getFieldValue("checadaDuplicadaBase") ? (
                                                                <FormItem
                                                                    name="checadaDuplicadaMin"
                                                                    label="Checada duplicada (min)"
                                                                    required
                                                                    margin
                                                                    initialValue={1}
                                                                    type="number"
                                                                    max={1440}
                                                                >
                                                                    <InputNumberItem />
                                                                </FormItem>
                                                            ) : null
                                                        }
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </Tabs>
                                )
                            }
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarHorario);